import { useCallback, useEffect, useRef, useState } from 'react';

export default function useCountdown(time = 5) {
  const intervalRef = useRef<NodeJS.Timeout | number>();
  const [timeLeft, setTimeLeft] = useState(0);

  const startCountdown = useCallback(() => {
    setTimeLeft(time);
  }, [time]);

  useEffect(() => {
    if (!timeLeft) {
      clearInterval(intervalRef.current as number);
    }

    if (timeLeft === time) {
      intervalRef.current = setInterval(
        () => setTimeLeft((old) => Math.max(old - 1, 0)),
        1000,
      );
    }
  }, [time, timeLeft]);

  return { timeLeft, startCountdown } as const;
}
